import { useState } from 'react';
import { ComponentProps } from '@frontend/types';
import { FormPacketFilters } from '../components/form-packet-filters/form-packet-filters';
import { FormPacketList } from '../components/form-packet-list/form-packet-list';
import { Category, FormOrPacketV2 } from '../types/form-packet-selector.types';
import { useFormPacketList } from './use-form-packet-list';

interface UseFormPacketSelectorProps {
  groupId: string;
  onSelect?: (item: FormOrPacketV2, type: Category) => void;
}

interface UseFormPacketSelectorResults {
  selectorProps: {
    formPacketFiltersProps: ComponentProps<typeof FormPacketFilters>;
    formPacketListProps: ComponentProps<typeof FormPacketList>;
  };
  selectedItem: FormOrPacketV2 | undefined;
  selectedCategory: Category | undefined;
  reset: () => void;
}

export const useFormPacketSelector = ({
  groupId,
  onSelect,
}: UseFormPacketSelectorProps): UseFormPacketSelectorResults => {
  const { searchFieldProps, switchChipGroupProps, formsQuery, packetsQuery } = useFormPacketList({ groupId });
  const [selectedItem, setSelectedItem] = useState<FormOrPacketV2>();
  const selectedCategory = switchChipGroupProps.value[0] as Category | undefined;

  const reset = () => {
    setSelectedItem(undefined);
    switchChipGroupProps.setValue([]);
  };

  return {
    selectorProps: {
      formPacketFiltersProps: {
        searchFieldProps,
        switchChipGroupProps,
      },
      formPacketListProps: {
        formsListInfiniteQueryProps: formsQuery,
        packetsListInfiniteQueryProps: packetsQuery,
        onSelect: (item) => {
          onSelect?.(item, selectedCategory ?? (Object.values(Category)[0] as Category) ?? Category.PACKETS);
          setSelectedItem(item);
        },
        selectedId: selectedItem?.id,
        category: selectedCategory || Category.PACKETS,
      },
    },
    selectedItem,
    selectedCategory,
    reset,
  };
};
